import { useEffect } from 'react';
import {
  VoicemailTagsAlertEvent,
  VoicemailUpdateEvent,
} from '@weave/schema-gen-ts/dist/shared/phone/v1/voicemail/message.pb';
import mitt, { Handler } from 'mitt';

export type VoicemailEventWithData = {
  event: VoicemailUpdateEvent;
};

export type VoicemailTagEventWithData = {
  event: VoicemailTagsAlertEvent;
};

export type VoicemailEvents = {
  'voicemail:update': VoicemailEventWithData;
  'voicemail:tag': VoicemailTagEventWithData;
};

export type VoicemailEventNames = keyof VoicemailEvents;
export type VoicemailEventHandler<T extends VoicemailEventNames> = Handler<VoicemailEvents[T]>;

/**
 * Independent emitter for voicemail events
 */
const voicemailEmitter = mitt<VoicemailEvents>();

/**
 * Hook to subscribe to voicemail events
 */
export const useVoicemailEventSubscription = <T extends VoicemailEventNames>(
  event: T,
  handler: VoicemailEventHandler<T>
) => {
  useEffect(() => {
    voicemailEmitter.on(event, handler);
    return () => {
      voicemailEmitter.off(event, handler);
    };
  }, [event, handler]);
};

/**
 * Hook to get the voicemail event emitter for publishing events
 */
export const useVoicemailEventEmitter = () => {
  return voicemailEmitter;
};
